import { useState, useRef, useEffect } from 'react';
import { checkCurrentEndpointHealth } from '../services/healthService';
import { getNodeInfo } from '../services/endpointService';

export const useHealthCheck = () => {
  const [isSystemHealthy, setIsSystemHealthy] = useState(null);
  const [healthServices, setHealthServices] = useState([]);
  const [healthCheckLoading, setHealthCheckLoading] = useState(true);
  const [lastHealthCheck, setLastHealthCheck] = useState(null);
  const [currentEndpoint, setCurrentEndpoint] = useState('');
  const [nodeInfo, setNodeInfo] = useState(null);
  const [healthCheckCompleted, setHealthCheckCompleted] = useState(false);
  const [healthCheckInProgress, setHealthCheckInProgress] = useState(false);

  const performHealthCheck = async (isInitial = false) => {
    if (healthCheckInProgress) {
      return;
    }

    setHealthCheckInProgress(true);
    if (isInitial) {
      setHealthCheckLoading(true);
    }

    try {
      const healthResult = await checkCurrentEndpointHealth();

      if (healthResult.isHealthy === null) {
        if (isInitial) {
          setHealthCheckLoading(false);
          setHealthCheckCompleted(true);
        }
        setHealthCheckInProgress(false);
        return null;
      }

      setIsSystemHealthy(healthResult.isHealthy);
      setHealthServices(healthResult.services || []);
      setCurrentEndpoint(healthResult.endpoint || '');
      setLastHealthCheck(new Date());

      if (isInitial && healthResult.endpoint) {
        try {
          const nodeData = await getNodeInfo(healthResult.endpoint);
          setNodeInfo(nodeData);
        } catch (error) {
          console.warn('Failed to get node info:', error);
        }
      }

      return healthResult.isHealthy;
    } catch (error) {
      console.error(`${isInitial ? 'Initial' : 'Periodic'} health check failed:`, error);
      setIsSystemHealthy(false);
      return false;
    } finally {
      setHealthCheckInProgress(false);
      if (isInitial) {
        setHealthCheckLoading(false);
        setHealthCheckCompleted(true);
      }
    }
  };

  return {
    isSystemHealthy,
    healthServices,
    healthCheckLoading,
    lastHealthCheck,
    currentEndpoint,
    nodeInfo,
    healthCheckCompleted,
    performHealthCheck
  };
};

